import './style.css'
import Accordion from "@/components/Accordion/accordion";

export default class FaqPage {
    static selector = '.faq-page'

    constructor(block) {
        this.block = block;
        this.accordion = this.block.querySelector('#faq-accordion');
        new Accordion(this.accordion);
    }

    // Public methods
    onResize() {}
    onScroll() {}
}
